import React, { useState } from 'react';
import { Input, Tag } from '@app/ui';

const InputTag = ({
    value = [],
    onChange,
    placeholderText = '',
    maxCount = 2,
    isHandleInput = false,
    disabled = false,
}: {
    value?: string[];
    onChange?: (tags: string[]) => void;
    placeholderText?: string;
    maxCount?: number;
    isHandleInput?: boolean;
    disabled?: boolean;
}) => {
    const [inputValue, setInputValue] = useState('');

    const handleKeyDown = e => {
        if (disabled) return;
        // For handle inputs, only Enter creates a tag. Otherwise, space, Enter, and ArrowRight all create tags
        const keysToAdd = isHandleInput
            ? ['Enter']
            : [' ', 'Enter', 'ArrowRight'];

        if (keysToAdd.includes(e.key) && inputValue.trim()) {
            const newTags = [...value, inputValue.trim()];
            onChange?.(newTags);
            setInputValue('');
            e.preventDefault(); // prevent key from triggering default behavior
        }
    };

    const removeTag = removedTag => {
        if (disabled) return;
        const newTags = value.filter(tag => tag !== removedTag);
        onChange?.(newTags);
    };

    return (
        <div
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 4,
                border: '1px solid #d9d9d9',
                borderRadius: 4,
                padding: '0 4px',
                opacity: disabled ? 0.6 : 1,
                cursor: disabled ? 'not-allowed' : 'default',
            }}
        >
            {value
                .slice(
                    0,
                    maxCount > 0
                        ? Math.min(maxCount, value.length)
                        : value.length,
                )
                .map(tag => (
                    <Tag
                        closable={!disabled}
                        key={tag}
                        onClose={() => removeTag(tag)}
                        style={{
                            margin: '4px 0',
                        }}
                    >
                        {tag}
                    </Tag>
                ))}
            {value.length > maxCount && (
                <Tag
                    style={{
                        margin: '4px 0',
                    }}
                >
                    +{value.length - maxCount} more
                </Tag>
            )}
            <Input
                value={inputValue}
                onChange={e => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
                bordered={false}
                disabled={disabled}
                style={{ minWidth: 100, flex: 1 }}
                placeholder={placeholderText}
            />
        </div>
    );
};

export default InputTag;
